import React from 'react'
import ButtonLink from '../Buttons/ButtonLink'
import { useNavigate } from 'react-router-dom'

const data = [
  {
    title: 'Zarządzaj lepiej, Obsługuj sprawniej',
    description: 'Dzięki naszym rozwiązaniom podniesiesz jakość obsługi na nowy poziom, zapewnisz swoim klientom najlepsze doświadczenie i zachęcisz ich do ponownych zamówień. Stwórz przewagę konkurencyjną i zdobądź klientów z całego świata',
    link: '/funkcje/wspolpraca',
    image: '/assets/images/icons/Zarządzaj lepiej obsługuj sprawniej.png'
  },
  {
    title: 'Chat z Klientem',
    description: 'Zbierz całą komunikację z Klientem w jednym miejscu, aby Twój zespół zawsze miał pełny kontekst i był na bieżąco. Koniec z powtarzającymi się pytaniami i chaosem w wiadomościach – teraz każdy może szybko znaleźć potrzebne informacje i sprawnie reagować na potrzeby Klientów',
    link: '/funkcje/chat',
    image: '/assets/images/icons/Chat_z_klientem.png'
  },
  {
    title: 'Oferty zakupowe',
    description: 'Twórz przejrzyste listy produktów, które są niezbędne do realizacji projektu oraz łatwo kontroluj budżet Klienta. Stwórz dla swoich Klientów indywidualny panel, w którym szybko zapoznają się ze wszystkimi materiałami projektowymi, listą produktów. Dzięki indywidulanemu panelowi Klienci będą mogli pisać komentarze, akceptować bądź odrzucać pozycje na liście',
    link: '/funkcje/oferty-zakupowe',
    image: '/assets/images/icons/Oferty zakupowe.png'
  }
]

function ServicesSection () {
  const navigate = useNavigate()

  return (
    <section className='tw-bg-gray tw-pt-20 md:tw-pt-28 xl:tw-pt-32'>
      <div className='tw-container xl:tw-max-w-7xl tw-mx-auto tw-flex tw-flex-col tw-items-center px-4 lg:px-0'>
        <div className='tw-flex tw-flex-col tw-gap-y-4 tw-max-w-3xl xl:tw-max-w-4xl'>
          <h3 className='tw-text-lg sm:tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-4xl tw-text-teal tw-font-bold tw-text-center'>Zarządzaj lepiej, Obsługuj sprawniej</h3>
          <p className='tw-text-base md:tw-text-lg xl:tw-text-xl tw-text-emerald tw-font-semibold tw-text-center'>Zapewnij swoim klientom płynną i profesjonalną komunikację</p>
        </div>

        <ul className='tw-mx-auto tw-mt-10 lg:tw-mt-16 tw-grid tw-grid-cols-1 tw-gap-6 md:tw-gap-8 lg:tw-gap-12 xl:tw-gap-16 md:tw-grid-cols-2 xl:tw-grid-cols-3'>
          {data.map((item, i) => {
            const originalLiClasses = 'tw-flex tw-flex-col tw-justify-between tw-gap-y-10 tw-bg-white tw-shadow-lg tw-max-w-xs md:tw-max-w-sm tw-py-8 tw-px-12 tw-rounded-lg'
            let additionalClasses = ''

            if (data.length === 3 && i === 2) {
              additionalClasses = ' md:tw-col-span-2 xl:tw-col-span-1 md:tw-mx-auto xl:tw-mx-0'
            }

            return (
              <li
                key={i}
                className={`${originalLiClasses}${additionalClasses}`}
              >
                <div className='tw-flex tw-flex-col tw-items-center'>
                  <img src={item.image} alt={item.title} className='tw-w-12 tw-h-12' />
                  <h4 className='tw-mt-3 tw-text-lg md:tw-text-xl tw-text-teal tw-font-semibold tw-text-center'>{item.title}</h4>
                  <p className='tw-mt-2 tw-text-sm md:tw-text-base tw-text-neutral tw-text-center'>{item.description}</p>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default ServicesSection
